exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".router-wrap {\n    padding-bottom: 50px;\n}\n\n.connect-open .router-wrap, .connect-open app-header, .connect-open app-footer {\n    opacity: .5;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_0264da94/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main